import { configureStore } from "@reduxjs/toolkit";
import tabsReducer from "../tabs/tabsSlice";
import salesDraftsReducer from "../state/salesDraftsSlice";
import uiStateReducer from "../state/uiStateSlice";

export const store = configureStore({
  reducer: {
    tabs: tabsReducer,
    salesDrafts: salesDraftsReducer,
    uiState: uiStateReducer,
  },
});

export default store;
